import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { invoices } from './queryKeys';
import envVars from '../../../constants/envVars';
import useQueryRequestParams from '../../../hooks/useQueryRequestParams';
const useGetMembershipInvoices = (hero_user_id, enabled) => {
    const additional = useQueryRequestParams();
    return useQuery({
        queryFn: () => axios.get(`${envVars.API_COMMERCE_HOSTNAME}subscription/backoffice/member/invoices`, {
            ...additional,
            params: { hero_user_id }
        }),
        queryKey: [invoices, hero_user_id],
        enabled
    });
};
export default useGetMembershipInvoices;
